enum Report {
    LaborMarket = 'laborMarket',
    HiringCost = 'hiringCost',
    VacanciesEfficiency = 'vacanciesEfficiency',
    Managers = 'managers',
    Vacancies = 'vacancies',
    VacanciesParameters = 'vacanciesParameters',
    CompetitorAnalysis = 'competitorAnalysis',
    PolitenessIndex = 'politenessIndex',
    PolitenessIndexByManagers = 'politenessIndexByManagers',
    ApplicantsActivity = 'applicantsActivity',
    BrandedVacancies = 'brandedVacancies',
    BrandedPages = 'brandedPages',
    ContactsEfficiency = 'contactsEfficiency',
    PublicationsEfficiency = 'publicationsEfficiency',
    CallTracking = 'callTracking',
    VacancyConversion = 'vacancyConversion',
    // tempexp_39570_start
    Talantix = 'talantix',
    // tempexp_39570_end
}

export const REPORTS_WITH_PAGINATION = [
    Report.Managers,
    Report.Vacancies,
    Report.PolitenessIndexByManagers,
    Report.CallTracking,
] as const;
export const REPORT_WITH_SORTING = [Report.Managers, Report.Vacancies] as const;
export const REPORTS_WITH_COLUMNS = [
    Report.Managers,
    Report.Vacancies,
    Report.PolitenessIndex,
    Report.PolitenessIndexByManagers,
] as const;

export default Report;
